export default defineNuxtRouteMiddleware((to) => {
    const entryUrl = useCookie('entry_url', {
      sameSite: 'lax'
    })

    if (!entryUrl.value) {
      const rawUrl = to.fullPath
      entryUrl.value = decodeURIComponent(rawUrl)
    }
  })
